module.exports = __webpack_public_path__ + "static/media/Es-ist-so-einfach2.852ae8de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Home/photos/Es-ist-so-einfach2.jpg
// module id = 244
// module chunks = 8